import CountryPageTemplate from './CountryPageTemplate';

export default function SloveniaPage() {
  return <CountryPageTemplate countryKey="si" />;
}